import { useRef, useEffect } from 'react';

export default function useDebouncedEffect(action: () => void, delay: number) {
    const debounceRef = useRef<NodeJS.Timeout>();
    useEffect(() => {
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(action, delay);

        return () => {
            clearTimeout(debounceRef.current);
        };

    }, [action, delay]);
};
